import Tipe91 from "./9.webp";
import Tipe92 from "./9luxury.webp";

const tipe9images = [Tipe91, Tipe92];

export default tipe9images;
